module.exports = __webpack_public_path__ + "static/media/light_rain.c43789f7.jpg";